
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<ngx-spinner size="large" bdColor="rgba(93, 32, 65, 0.75)">
<!-- <img style="margin-bottom: 300px;" src='/assets/lebtivitylogo.png' /> -->
</ngx-spinner>
<div class="row align-items-center pageheader">

  <div style="width: 90%; margin:0 auto; height: max-content; padding-left:5px; padding-right: 5px;"
    class="align-items-center">
    <div class="eventsheader">
      {{eventsTitle}}
    </div>
    <div *ngIf="!isSearch" class="headerbuttonsgroup">
      <!-- <mat-checkbox (click)="showFree()" ngModel="free" class="headercheckbox">Free</mat-checkbox>
      <mat-checkbox (click)="showPaid()" ngModel="paid" class="headercheckbox">Paid</mat-checkbox> -->
      <label class="checkbox">
        <input (click)="showAll()" [checked]="all" class="headercheckbox" type="checkbox" />
        <span class="headercheckboxlabel">All</span>
      </label>
      <label class="checkbox">
        <input (click)="showFree()" [checked]="free" class="headercheckbox" type="checkbox" />
        <span class="headercheckboxlabel">Paid</span>
      </label>
      <label class="checkbox">
        <input (click)="showPaid()" [checked]="paid" class="headercheckbox" type="checkbox">
        <span class="headercheckboxlabel">Free</span>
      </label>
      <button [ngClass]="{ 'issorted': sortPopularity }" (click)="sortByPopularity()" style="border-left: 1px solid rgb(212, 210, 206);" class="headerbutton"><i
          class="fa fa-heart sorticon"></i>By Popularity</button>
      <button [ngClass]="{ 'issorted': !sortPopularity }" (click)="sortByTime()" class="headerbutton"><i
          class="fa fa-clock-o sorticon"></i>By Time</button>

      <mat-form-field hidden appearance="outline" class="headerbutton">
        <mat-label><i class="fa fa-calendar sorticon"></i>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input [(ngModel)]="start_date" matStartDate placeholder="Start date">
          <input [(ngModel)]="end_date" (dateChange)="dateRange()" matEndDate placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker touchUi #picker></mat-date-range-picker>
      </mat-form-field>
      <button class="headerbutton" (click)="picker.open()">Date Range</button>
      <!-- <button class="headerbutton" style="margin-left:10px" (click)="dateRange()">search</button> -->
      <!-- <mat-form-field class="row" (click)="picker.open()" appearance="outline">
      <mat-label><i class="fa fa-calendar sorticon"></i>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input formControlName="start_date" matStartDate placeholder="Start date">
        <input formControlName="end_date" matEndDate placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field> -->

      <!-- <button class="headerbutton"><i class="fa fa-calendar sorticon"></i>Date Range</button> -->
    </div>
    <!-- <div class="col">
    <mat-form-field style="float: right;" appearance="outline " [formGroup]="sortForm">
      <mat-select placeholder="Sort" enableedOptionCentering formControlName="sort" (selectionChange)="sortEvent()">
        <mat-option *ngFor="let sort of sort" [value]="sort.value">
          {{sort.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->
  </div>
</div>





<!-- LISTS OF EVENTS -->
<!-- END FEATURED EVENTS BANNER -->

<div style="background-color:  rgb(241, 235, 228); min-height:100%">
  <div *ngIf="isSearch" style="width: 90%; margin: 0 auto">
    <button mat-raised-button class="pasteventsbutton" *ngIf="isPassedEvents" (click)="showAllEvents()">Include passed events in search results</button>
    <button mat-raised-button class="pasteventsbutton" *ngIf="!isPassedEvents" (click)="showCurrentEvents()">Exclude passed events from results</button>
    </div>
  <div style="display: flex; flex-wrap:wrap; background-color: rgb(241, 235, 228); width: 90%; margin: 0 auto">
    <div *ngFor="let item of allEvents" [ngSwitch]="item.type" class="container">
      <!-- STANDARD EVENT -->
      <div class="info ">
        <div class="column">
          <div class="maincard" *ngSwitchCase="EVENT_TYPE_STANDARD.toLocaleLowerCase()">
            <div class="cancelledevent" *ngIf="item.status == EVENT_STATUS_CANCELLED.toLocaleLowerCase()">
              <!-- EVENT Thumbnail-->
              <img class="eventimg cancelledimage" (click)="goToEventPage(item)"
                src="{{'https://events.globalistic.tech/'+ item.images[0].filename}}" />
              <!-- EVENT Content-->
              <div class="maincard-content">
                <h1 matTooltip="{{item.event_name}}" class="title">{{item.event_name}}</h1>
                <!-- <h2 matTooltip="{{item.location}}" class="sub_title">{{item.location}}</h2> -->
                <p class="description">{{item.organizer_name}}</p>
                  <span matTooltip="{{item.location}}" class="details">
                    <i style="margin-right: 3px;" class="fa fa-location-arrow"></i> {{item.location}}
                  </span><br>
                  <span *ngIf="item.passedEvent" class="details">
                    <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                    This event has passed
                  </span>
                  <span *ngIf="!item.passedEvent" class="details">
                    <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                    {{item.firstDate | date: 'MMM dd,yyyy'}} - {{item.lastDate | date: 'MMM dd,yyyy'}} from {{item.event_dates[0].start_time }} until {{item.event_dates[0].end_time}}
                  </span>

                  <span class="details" *ngIf="feesFeature">
                    <i class="fa fa-money"></i>
                    <a href="#">{{item.min_fee}} USD</a>
                  </span>
                  <span class="details" *ngIf="numberOfViewsFeature">
                    <i class="fa fa-eye"></i> {{item.visit == null ? '0' : item.visit}}</span>

                <div class="cancelledtext">Event Cancelled</div>
              </div>
            </div>
            <div *ngIf="item.status != EVENT_STATUS_CANCELLED.toLocaleLowerCase()">
              <i class="material-icons faviconwhite" *ngIf="item.bookmark == null"
                (click)="bookmarkEvent(item)">favorite</i>
              <i class="material-icons faviconyellow" *ngIf="item.bookmark != null"
                (click)="bookmarkEvent(item)">favorite</i>
              <img class="eventimg" (click)="goToEventPage(item)"
                src="{{'https://events.globalistic.tech/'+ item.images[0].filename}}" />
              <!-- Post Content-->
              <div class="maincard-content">
                <h1 matTooltip="{{item.event_name}}" class="title">{{item.event_name}}</h1>
                <!-- <h2 matTooltip="{{item.location}}" class="sub_title">{{item.location}}</h2> -->
                <p class="description">{{item.organizer_name}}</p>
                <div class="maincard-meta">
                  <span matTooltip="{{item.location}}" class="details">
                    <i style="margin-right: 3px;" class="fa fa-location-arrow"></i> {{item.location}}
                  </span>

                  <span *ngIf="item.passedEvent" class="details">
                    <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                    This event has passed
                  </span>
                  <span *ngIf="!item.passedEvent" class="details">
                    <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                    {{item.firstDate | date: 'MMM dd,yyyy'}} - {{item.lastDate | date: 'MMM dd,yyyy'}} from {{item.event_dates[0].start_time }} until {{item.event_dates[0].end_time}}
                  </span>

                  <span class="details" *ngIf="feesFeature">
                    <i class="fa fa-money"></i>
                    <a href="#">{{item.min_fee}} USD</a>
                  </span>
                  <span class="details" *ngIf="numberOfViewsFeature">
                    <i class="fa fa-eye"></i> {{item.visit == null ? '0' : item.visit}}</span>
                </div>
                <bar-rating *ngIf="ratingFeature" [theme]="'fontawesome'" [(rate)]="item.average_rating" [max]="5"
                  [readOnly]="true">
                </bar-rating>
                <share-buttons theme="modern-light" [include]="['facebook','whatsapp','copy']" [show]="3"
                [url]="'https://events.globalistic.tech/event/'+item.link" [autoSetMeta]="false" [showText]="false"
                  [size]="-2"></share-buttons>
                  <div *ngIf="!item.passedEvent && loggedIn" class="addtocalendar" ngbDropdown role="group">
                    <button mat-raised-button class="addtocalendarbutton">Add to Calendar</button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      <mat-checkbox color="primary"
                         ngbDropdownItem
                        *ngFor="let date of item.event_dates" [checked]="isCheckedAndDisabled(date)" (click)="book(date, item)">{{date.date | date: 'MMM dd,yyyy'}}
                      </mat-checkbox>
                  </div>
                </div>

                <div *ngIf="!item.passedEvent && !loggedIn" class="addtocalendar" role="group">
                  <button (click)="login()" mat-raised-button class="addtocalendarbutton">Add to Calendar</button>
              </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <!-- END STANDARD EVENT -->

      <div class="info ">
        <div class="column">
          <div class="maincard" *ngSwitchCase="EVENT_TYPE_FEATURED.toLocaleLowerCase()">
        <!-- FEATURED EVENTS BANNER -->
          <!-- Post-->
            <!-- Thumbnail-->
            <i class="material-icons faviconwhite" *ngIf="item.bookmark == null"
              (click)="bookmarkEvent(item)">favorite</i>
            <i class="material-icons faviconyellow" *ngIf="item.bookmark != null"
              (click)="bookmarkEvent(item)">favorite</i>
            <img (click)="goToEventPage(item)" class="eventimg"
              src="{{'https://events.globalistic.tech/'+ item.images[0].filename}}" />
            <div class="ribbon-wrapper">
              <!-- <div class="glow">&nbsp;</div> -->
              <div style="background-color:#5d2041" class="ribbon-front">
                Featured Event
              </div>
              <div style="border-color: transparent #5d2041 transparent transparent" class="ribbon-edge-topleft"></div>
              <div style="border-color: transparent transparent transparent #5d2041 ;" class="ribbon-edge-topright">
              </div>
              <div style="border-color: transparent #5d2041 transparent transparent" class="ribbon-edge-bottomleft">
              </div>
              <div style="border-color: transparent transparent transparent #5d2041;" class="ribbon-edge-bottomright">
              </div>
            </div>
            <!-- Post Content-->
            <div class="maincard-content">
              <h1 matTooltip="{{item.event_name}}" class="title">{{item.event_name}}</h1>
              <!-- <h2 matTooltip="{{item.event.location}}" class="sub_title">{{item.event.location}}</h2> -->
              <p class="description">{{item.organizer_name}}</p>
    
              <div class="maincard-meta">
                <span matTooltip="{{item.location}}" class="details">
                  <i style="margin-right: 3px;" class="fa fa-location-arrow"></i> {{item.location}}
                </span>
                <span *ngIf="item.passedEvent" class="details">
                  <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                  This event has passed
                </span>
                <span *ngIf="!item.passedEvent" class="details">
                  <i style="margin-right: 3px;" class="fa fa-clock-o"></i>
                  {{item.firstDate | date: 'MMM dd,yyyy'}} - {{item.lastDate | date: 'MMM dd,yyyy'}} from {{item.event_dates[0].start_time }} until {{item.event_dates[0].end_time}}
                </span>
    
                <span class="details" *ngIf="feesFeature">
                  <i class="fa fa-money"></i>
                  <a href="#">{{item.min_fee}} USD</a>
                </span>
                <span class="details" *ngIf="numberOfViewsFeature">
                  <i class="fa fa-eye"></i> {{item.visit == null ? '0' : item.visit}}</span>
              </div>
    
              <bar-rating *ngIf="ratingFeature" [theme]="'fontawesome'" [(rate)]="item.average_rating" [max]="5"
                [readOnly]="true">
              </bar-rating>
              <share-buttons theme="modern-light" [include]="['facebook','whatsapp','copy']" [show]="3"
              [url]="'https://events.globalistic.tech/event/'+item.link" [autoSetMeta]="false" [showText]="false"
                [size]="-2"></share-buttons>
                <div *ngIf="!item.passedEvent && loggedIn" class="addtocalendar" ngbDropdown role="group">
                  <button mat-raised-button class="addtocalendarbutton">Add to Calendar</button>
                  <div class="dropdown-menu" ngbDropdownMenu>
                    <mat-checkbox color="primary"
                       ngbDropdownItem
                      *ngFor="let date of item.event_dates" [checked]="isCheckedAndDisabled(date)" (click)="book(date, item)">{{date.date | date: 'MMM dd,yyyy'}}
                    </mat-checkbox>
                </div>
              </div>
              <div *ngIf="!item.passedEvent && !loggedIn" class="addtocalendar" role="group">
                <button (click)="login()" mat-raised-button class="addtocalendarbutton">Add to Calendar</button>
            </div>
            </div>
          </div>
        </div>
    
  
    
      <!-- ADVERTISEMENT -->
      <div class="info">
        <!-- Normal Demo-->
        <div class="column">
          <!-- Post-->
          <div  (click)="navigateAds(item.link, item.url)"  class="maincard ad" *ngSwitchCase="EVENT_TYPE_AD.toLocaleLowerCase()">
            <!-- Thumbnail-->

            <img class="eventimg" src="{{'https://events.globalistic.tech/'+ item.image}}" />
            <!-- Post Content-->
            <div class="maincard-content ">
              <div class="title">{{item.name}}</div>
              <div class="sub_title">{{item.description}}</div>
              <p class="description">{{item.link}}{{item.url}}</p>
            </div>

          </div>
        </div>
      </div>
      <!-- END ADVERTISEMENT -->

    </div>
    <!-- END ngFor -->
  </div>
</div>
<!-- END LISTS OF EVENTS -->
